// /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import env from '../../../env';
import { VehiclesOverview as component1 } from './installations/1/overview';
import { VehiclesOverview as component2 } from './installations/2/overview';
import { VehiclesOverview as component3 } from './installations/3/overview';
import { VehiclesOverview as component4 } from './installations/4/overview';
import { VehiclesOverview as component6 } from './installations/6/overview';
import { VehiclesOverview as component7 } from './installations/7/overview';
import { VehiclesOverview as component8 } from './installations/8/overview';

import { AppClientId } from '../../Shared/constants';
import * as installationConstants1 from '../../KanbanBoards/installations/1/constants';

let component = component1;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    component = component1;
    break;
  case AppClientId.IDWLEASE:
    component = component1;
    break;
  case AppClientId.HARRY_NIJBOER:
    component = component2;
    break;
  case AppClientId.HOOIKAMMER:
    component = component3;
    break;
  case AppClientId.IDW_GMBH:
    component = component4;
    break;
  case AppClientId.AUTOWIENTJES:
    component = component6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    component = component7;
    break;
  case AppClientId.HILTERMANN:
    component = component8;
    break;
  default:
    component = component1;
}

export const VehiclesOverview = component;
